export default {
  label: '核验信息',
  icon: 'el-icon-success',
  column: [
    {
      type: 'input',
      label: '核验人员',
      span: 8,
      display: true,
      size: 'small',
      prop: 'visitPeople',
      disabled: true,
    },
    {
      type: 'select',
      label: '核验结果',
      span: 8,
      display: true,
      size: 'small',
      prop: 'visitResult',
      dicData: [
        {
          label: '核验中',
          value: 1,
        },
        {
          label: '核验完成',
          value: 2,
        },
      ],
      rules: [
        {
          required: true,
          message: '请选择核验结果',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '是否回访',
      prop: 'isVisit',
      type: 'radio',
      span: 8,
      dicData: [
        {
          label: '是',
          value: 0,
        },
        {
          label: '否',
          value: 1,
        },
      ],
    },
    {
      type: 'datetime',
      label: '回访时间',
      span: 8,
      display: true,
      size: 'small',
      prop: 'visitTime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      rules: [],
    },
    {
      label: '回访形式',
      span: 8,
      display: true,
      size: 'small',
      prop: 'visitType',
      formslot: true,
      clearable: true,
    },
    {
      type: 'select',
      label: '满意度',
      span: 8,
      display: true,
      size: 'small',
      prop: 'satisfaction',
      dicData: [
        {
          label: '一般',
          value: 0,
        },
        {
          label: '比较满意',
          value: 1,
        },
        {
          label: '非常满意',
          value: 2,
        },
      ],
      rules: [],
    },
    {
      type: 'textarea',
      label: '核验备注',
      span: 24,
      display: true,
      size: 'small',
      prop: 'remark3',
      maxlength: 200,
      showWordLimit: true,
    },
    {
      label: '文件上传',
      prop: 'accessoriesStr4',
      type: 'upload',
      span: 24,
      propsHttp: {
        res: 'data',
        url: 'link',
        name: 'originalName',
      },
      //tip: '只能上传不超过5M的文件或图片',
      action: '/api/v4ward/oss/customEndpoint/put-file',
      dataType: 'string',
    },
  ],
};
